export default "__VITE_ASSET__G_o_kgBl__"